import { BitmapImage2D, ImageUtils } from "@awayjs/stage";
console.debug("AwayFL-Player - 0.2.45");
export { AVMPlayer } from "./lib/AVMPlayer";
export { AVM1Player } from "./lib/AVM1Player";
export { AVM2Player } from "./lib/AVM2Player";
export { LoaderEvent } from "@awayjs/core";
export { EventBase } from "@awayjs/core";
export { StageManager } from "@awayjs/stage";
export { Settings as AVM2Settings } from "@awayfl/avm2";
export { PlayerGlobal } from "@awayfl/playerglobal";
ImageUtils.registerDefaults(function () { return new BitmapImage2D(1, 1, true, 0x0); }, null, null, null);
import * as Box2D_1 from "./lib/Box2D";
export { Box2D_1 as Box2D };
import * as Box2DLegacy_1 from "./lib/Box2Dold";
export { Box2DLegacy_1 as Box2DLegacy };
import * as Box2DRaycast_1 from "./lib/Box2Dold_Raycast";
export { Box2DRaycast_1 as Box2DRaycast };
